import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAdminAuthHeaders } from "./utils/adminAuth";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URI || "http://localhost:8080/graphql",
});

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    ...getAdminAuthHeaders(),
  },
}));

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
